module.exports = __webpack_public_path__ + "img/onet.92b51b48.png";